import { ChangeDetectionStrategy, Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { EmployerMailingAddressFormGroup } from '../../../../../forms/employer-mailing-address-form-group';
import { CANADA_COUNTRY_ID } from '../../../../../consts/consts';

@Component({
  selector: 'app-mailing-address-form-grid',
  templateUrl: './mailing-address-form-grid.component.html',
  styleUrls: ['./mailing-address-form-grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MailingAddressFormGridComponent implements OnInit {
  @Input() form!: EmployerMailingAddressFormGroup;
  @Input() formSubmitted = false;
  @Input() showTitle = true;

  private destroyRef = inject(DestroyRef);

  public ngOnInit(): void {
    this.setAddressEnabled(!this.form.controls.sameAsHeadOffice.value);

    this.form.controls.sameAsHeadOffice.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(sameAsHeadOffice => {
        if (sameAsHeadOffice) {
          this.form.controls.address.reset({ countryId: CANADA_COUNTRY_ID });
        }
        this.setAddressEnabled(!sameAsHeadOffice);
      });
  }

  private setAddressEnabled(enabled: boolean): void {
    if (enabled) {
      this.form.controls.address.enable();
    } else {
      this.form.controls.address.disable({ emitEvent: false });
    }
  }
}
